export const LOGO_VARIANT_NONE = "__NO_LOGO__";
